import React, { useState } from 'react';
import type { ReactElement } from 'react';
import { FilterMd, PillButton } from '@construct-kit/core';
import FilterDialog from '../../searchResult/refinements/components/FilterDialog';
import type { SelectedFiltersOptionsType } from '../../../shared/model/constants/filterTypes';
import { trackSearchRefinementModalOpen } from '../../../shared/tracking/tealium/tracking';

type FilterModalProps = {
  initialFilterOptions: SelectedFiltersOptionsType;
  selectedFilterOptionsHomepage: SelectedFiltersOptionsType;
  setSelectedFilterOptionsHomepage: (value: SelectedFiltersOptionsType) => void;
  handleSearchOnClick: () => void;
  disabled: boolean;
};

export const FilterModal = ({
  initialFilterOptions,
  selectedFilterOptionsHomepage,
  setSelectedFilterOptionsHomepage,
  handleSearchOnClick,
  disabled,
}: FilterModalProps): ReactElement => {
  const [shouldOpenFilterDialog, setShouldOpenFilterDialog] = useState(false);

  const onFilterClickOpen = () => {
    trackSearchRefinementModalOpen({
      searchMode: 'search',
      userAction: 'filters-button',
    });
    setShouldOpenFilterDialog(true);
  };

  return (
    <>
      <PillButton
        sizeVariant="medium"
        iconLeft={<FilterMd />}
        hideLabel
        onClick={() => onFilterClickOpen()}
        aria-label="All filters"
        disabled={disabled}
      >
        Filter
      </PillButton>
      {shouldOpenFilterDialog && (
        <FilterDialog
          isOpen={shouldOpenFilterDialog}
          appElement={() => document.getElementById('wrapper') ?? ''}
          onClose={() => {
            setShouldOpenFilterDialog(false);
          }}
          initialFilterOptions={initialFilterOptions}
          selectedFiltersOptions={selectedFilterOptionsHomepage}
          setSelectedFiltersOptions={setSelectedFilterOptionsHomepage}
          handleSearchOnClick={handleSearchOnClick}
        />
      )}
    </>
  );
};
